module.exports = __webpack_public_path__ + "img/6.97c17f99.svg";